export default {
  message: 'Admin',
};
